const CURRENCY_CHAR = "$";

export function formatPrice(price?: string | number) {
  if (!price) return "";
  const priceStr = price.toString();
  return priceStr.slice(0, priceStr.length - 2) + CURRENCY_CHAR;
}
